import { IExceptionStatus } from 'core-components/sitebuilder/models/IUserRuleExceptions'

export interface IUserAvatar {
  Thumbnail: string
  Original: string
  Normal: string
  PublicId: string
}

export interface IUser {
  id: string
  UID: string
  email: string
  canSimulateUsers: boolean
  firstName: string
  lastName: string
  country: string
  locale: string
  hpOrg: string
  geoMarket: string
  language: string
  countries: string[]
  locales: string[]
  languages: string[]
  hpOrgs: string[]
  geoMarkets: string[]
  roleIds: string[]
  ssoData: any[]
  password: string
  canBeSimulated: string
  lastLogonTime: string
  avatar: IUserAvatar | null
  exceptionStatus: IExceptionStatus[] | null
  AD_Manager: string | null
  AD_ManagerName: string | null
  AD_LocationCode: string | null
  AD_StatusAD: string | null
  AD_BusinessRegion: string | null
  AD_JobFunction: string | null
  AD_JobFamily: string | null
  TD_EmployeeType: string | null
  TD_StatusTD: string | null
  TD_Location: string | null
  TD_RTM: string | null
  TD_Role: string | null
  TD_SubRole: string | null
  TD_ReportsToHPID: string | null
}

const initialData: IUser = {
  id: '',
  UID: '',
  email: '',
  firstName: '',
  lastName: '',
  country: '',
  canSimulateUsers: false,
  locale: '',
  hpOrg: '',
  geoMarket: '',
  language: '',
  countries: [] as string[],
  locales: [] as string[],
  languages: [] as string[],
  hpOrgs: [] as string[],
  geoMarkets: [] as string[],
  roleIds: [] as string[],
  ssoData: [] as any[],
  password: '',
  canBeSimulated: '',
  lastLogonTime: '',
  avatar: null as IUserAvatar | null,
  exceptionStatus: null as IExceptionStatus[] | null,
  AD_Manager: null,
  AD_ManagerName: null,
  AD_LocationCode: null,
  AD_StatusAD: null,
  AD_BusinessRegion: null,
  AD_JobFunction: null,
  AD_JobFamily: null,
  TD_EmployeeType: null,
  TD_StatusTD: null,
  TD_Location: null,
  TD_RTM: null,
  TD_Role: null,
  TD_SubRole: null,
  TD_ReportsToHPID: null,
}

export const createUser = (data?: Partial<IUser>): IUser => ({
  ...initialData,
  ...data,
})
